import apiClient from '../services/apiClient'

export const getAllCoachs = async () => {
    return (await apiClient.get('/coachs', { params: { role: 'ROLE_ADMIN' } })).data
}

export const resetPassword = async (email: string) => {
    return await apiClient.post('/coachs/reset-password', { email }, { params: { role: 'ROLE_ADMIN' } })
}
